module.exports = __webpack_public_path__ + "static/img-certified-01-f3aca24c86afd571d115d5f62e3c8a78.png";